import React from "react";

import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import AchievementsSection from "../components/AchievementsSection";
import WhyChooseUs from "../components/WhyChooseUs";
import InitiativeSection from "../components/HeroInitiativeSection";
import ContactSection from "../components/ContactSection";
import ReviewsSection from "../components/ReviewsSection";
import FaqSection from "../components/FaqSection";
import { whyChooseUsData } from "../data/homeData";

const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <AchievementsSection />
      <WhyChooseUs data={whyChooseUsData} />
      <InitiativeSection />
      <ContactSection />
      <ReviewsSection />
      <FaqSection />
    </>
  );
};

export default Home;
